import { useState } from 'react';
import DraggableList from 'react-draggable-list';
import { StandardComp } from '../atoms/standardComp';

export const OrderAnswers = ({answers, updateOrder1}) => {   
      const [dragAnswers, updateDragAnswers] = useState(answers)
 
      const handleAnswersChange = (newAnswers) => {
        updateDragAnswers(newAnswers);
        console.log(newAnswers)
        updateOrder1(newAnswers);
      };
      console.log(answers)
      const AnswerTemplate = ({ item, dragHandleProps, itemSelected }) => (
  
        <div className={`dragHandle no-padding`} {...dragHandleProps}>
            <StandardComp
            editClass={`${itemSelected !== 0 ? "active-standard" : ""}`} style={{"transition": "0.3s"}}
            content={
                <div className="horizontal multiplechoice-button">
                    <p className="standard-text-color">{item.text}</p>
                </div>
            }
            />
        </div>
      );
    
      return (
        <div className="standard-margin-top">
            <DraggableList
              itemKey="inputID"
              template={AnswerTemplate}
              list={dragAnswers}
              onMoveEnd={handleAnswersChange}
            />
          </div>
      );
}